export default "__VITE_ASSET__Bu9QnLO1__"